import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';

import FlagsIcon from '@ott/flags-icon';

import { LANGUAGES_DICTIONARY } from '../../helpers/constants';

import styles from './Locale.scss';

class Locale extends PureComponent {
  static propTypes = {
    lang: PropTypes.string.isRequired,
    selectedLang: PropTypes.string,
    showOnlyFlag: PropTypes.bool,
    onSelectLocale: PropTypes.func,
    isClickable: PropTypes.bool,
  };

  handleSelectLocale = (event) => {
    const { onSelectLocale, lang } = this.props;

    onSelectLocale && onSelectLocale(event, lang);
  };

  render() {
    const { lang, showOnlyFlag, isClickable, selectedLang, onSelectLocale } = this.props;

    const { currency, title } = LANGUAGES_DICTIONARY[lang];

    const localeNode = (
      <div
        className={cls(styles.localeContainer, {
          [styles.isCurrentLocale]: lang === selectedLang,
          [styles.isClickable]: isClickable,
        })}
      >
        <div className={styles.flagIconContainer}>
          <FlagsIcon lang={lang} className={styles.flagIcon} />
        </div>
        {!showOnlyFlag && (
          <React.Fragment>
            <span className={styles.currency}>{currency}</span>,&nbsp;{title}
          </React.Fragment>
        )}
      </div>
    );

    if (!!onSelectLocale) {
      return (
        <a onClick={this.handleSelectLocale} data-locator="localeLink">
          {localeNode}
        </a>
      );
    }

    return localeNode;
  }
}

export default Locale;
